import { Banner, CardItem, HorizontalWordLoop } from '@/components'
import mailer from '../assets/images/about.png'
import { CTA } from '@/components/CTA'
import { Fade, Flip, Zoom, Roll, JackInTheBox, Slide } from "react-awesome-reveal";
import { windowWidth } from '@/services/services';
import { Helmet } from 'react-helmet-async';

export const About = () => {
    return (
        <>

            <Helmet>
                <title>Morse Code Academy | About</title>
                <meta name="title" content="Morse Code Academy | About" />
                <meta
                    name="description"
                    content="Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate."
                />
        
                <meta
                    property="og:description"
                    content="Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate."
                />
                <meta property="og:image" content={mailer} />
                <meta
                    property="og:title"
                    content="Morse Code Academy"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://morsecodeacademy.site/about" />
            </Helmet>
            <JackInTheBox triggerOnce={true} delay={1000}>
                <Banner
                    subtitle={"THE STORY"}
                    title={'TURNING DOTS AND DASHES INTO DREAMS: THE <span class"stroke white">SCOUT</span> WHO <span class"stroke white">INNOVATED</span>'}
                    image={mailer}
                    description="From the campfire to the digital frontier, one scout’s passion for Morse code ignites a groundbreaking journey."
                />
            </JackInTheBox>
            <div className="   container pt-lg-5 ">
                <div className="row justify-content-center pt-5">
                    <div className="col-lg-12 mt-2">
                        <Fade triggerOnce={true} delay={200}><h6 className="sub-title text-white">Our Story.</h6></Fade>
                    </div>
                    <div className="col-lg-12">
                        <Fade triggerOnce={true} delay={400}>  <h3 className='text-white mt-2'>IT STARTED WITH A <span className="stroke">VISION</span></h3></Fade>
                        <Fade triggerOnce={true} delay={600}>
                            <p className="text-white mt-2 fs-20">
                                Serouj Khanjihanian, a passionate boy scout, found joy and purpose in the challenges of scouting. Among his many adventures, learning Morse code captured his heart. To him, it was more than dots and dashes; it was a timeless language that bridged cultures and saved lives. Inspired by campfire tales of Morse code's impact, Serouj mastered the skill and shared it with his fellow scouts, unaware that this passion would shape his future.
                            </p>

                            <p className="text-white mt-2 fs-20">
                                As he grew older, Serouj pursued a degree in software engineering, blending his love for problem-solving with his fond memories of scouting. During a lecture on app development, he had an epiphany: why not combine his technical expertise with his passion for Morse code? He envisioned an innovative app that made learning Morse code engaging, accessible, and multilingual.
                            </p>

                            <p className="text-white mt-2 fs-20">
                                After months of dedication, Serouj launched the Morse Code Academy app. It offered immersive features like unlimited drills, daily challenges with motivational quotes, and the ability to transmit Morse code through flashlight signals, audio beeps, or text. Designed to teach Morse code in six languages—English, Armenian, Arabic, Spanish, French, and Russian—the app became a global success.
                            </p>

                        </Fade>

                    </div>
                </div>

            </div>
            <Fade triggerOnce={true} delay={100}>
                <HorizontalWordLoop title={"ABOUT MORSE CODE ACADEMY"} />
            </Fade>

            <CTA
                title={"Let's Bring <br /><span class='stroke '>Your</span> Ideas To <span class='stroke '>Life</span>"}
                description={"Are you ready to turn your vision into a reality? <br> Whether you’re just getting started or looking to level up an existing idea, now is the perfect time to make it happen. Let’s build something great together!"} />
        </>
    )
}